<template>
  <div class="doctor-user">
    <div class="container">
      <!-- 搜索条件 -->
      <div class="doctor-user-search">
        <el-form
          ref="doctorUserFormRef"
          :inline="true"
          :model="doctorUserForm"
          class="demo-form-inline"
        >
          <el-form-item label="绑定时间">
            <el-date-picker
              v-model="doctorUserForm.date"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              format="yyyy - MM - dd"
              unlink-panels
              range-separator="——"
              end-placeholder="结束日期"
              start-placeholder="开始日期"
              size="small"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="用户手机号">
            <el-input
              v-model="doctorUserForm.phone"
              clearable
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="searchBtn">
              查 询<i class="el-icon-search el-icon--right" />
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="doctor-user-table">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="doctorUserData"
          style="width: 100%"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            :fixed="item.fixed"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row.create_time | dateFormat }}
              </div>

              <div v-else-if="item.prop == 'status_time'">
                {{ scope.row.status_time | dateFormat }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                @click="toDetail(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('41') : false
                "
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import marketing from "@/api/marketing";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      moduleName: 1,
      doctorUserForm: {
        date: [],
        phone: "",
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "患者昵称",
          prop: "user_name",
          width: "auto",
          fixed: "left",
        },
        {
          label: "用户手机号",
          prop: "phone",
          width: "auto",
          fixed: false,
        },

        {
          label: "关联时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },

        {
          label: "绑定时间",
          prop: "status_time",
          width: "auto",
          fixed: false,
        },
      ],
      doctorUserData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        {},
        this.pagination,
        this.doctorUserForm,
        this.$route.query
      );
      params = _.omit(params, ["date"]);
      let times = this.doctorUserForm.date;
      params["time_start"] = times ? times[0] : "";
      params["time_end"] = times ? times[1] : "";
      marketing.getDoctorLevelRewardPatientList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.doctorUserData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 查看详情
    toDetail(row) {
      let { user_id } = row;
      this.$router.push({
        path: "/home/patient/userdetail",
        query: {
          user_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.doctor-user {
  .doctor-user-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .doctor-user-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
